import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as server from '../server';

export const useCheckIfUsernameIsAvailable = () => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async ({ userName, email, token }) => {
        const { data: { usernameAvailable, suggestions = [] } } = await server.checkIfUsernameIsAvailable({
            userName,
            email,
            token,
            casinoName
        });

        return { usernameAvailable, suggestions };
    }, [
        casinoName
    ]);
};
